import {add} from '@elements/scroll-animations';
import {findAll, addClass, closest, find, on, findIn, findAllIn, hasClass, setAttribute, removeAttribute} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {onEnterViewPort} from '@elements/viewport-utils';

let selectors = {
    base: '.js-scroll-buttons__group',
    left: '.js-scroll-buttons--left',
    right: '.js-scroll-buttons--right',
    scrollableContainer: '.js-scroll-buttons__scrollable-container',
    buttons: '.js-scroll-buttons'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        console.log("found scroll buttons", baseElement)
        const rightButton = findIn(selectors.right, baseElement);
        const leftButton = findIn(selectors.left, baseElement);

        const scrollableContainer = findIn(selectors.scrollableContainer, baseElement); // container can't be the same as baseElement!
        const scrollButtons = findIn(selectors.buttons, baseElement);

        on('click', function() {
            console.log("scroll buttons rightButton", rightButton)

            scrollableContainer.scrollTo({
                top: 0,
                left: scrollableContainer.scrollLeft + 200,
                behavior: 'smooth'
            })

            removeAttribute('disabled', leftButton);
            if(scrollableContainer.scrollLeft + scrollableContainer.clientWidth >= scrollableContainer.scrollWidth) {
                setAttribute('disabled', '', rightButton);
            }
        }, rightButton);

        on('click', function() {
            console.log("scroll buttons leftButton", leftButton)

            scrollableContainer.scrollTo({
                top: 0,
                left: scrollableContainer.scrollLeft - 200,
                behavior: 'smooth'
            })

            removeAttribute('disabled', rightButton);
            if(scrollableContainer.scrollLeft <= 0) {
                setAttribute('disabled', '', leftButton);
            }
        }, leftButton);

        on('scrollend', () => {
            if(scrollableContainer.scrollLeft + scrollableContainer.clientWidth >= scrollableContainer.scrollWidth) {
                setAttribute('disabled', '', rightButton);
            }
            if(scrollableContainer.scrollLeft <= 0) {
                setAttribute('disabled', '', leftButton);
            }
        }, scrollableContainer);

        on('scroll', () => {
            removeAttribute('disabled', leftButton);
            removeAttribute('disabled', rightButton);

            if(scrollableContainer.scrollLeft + scrollableContainer.clientWidth >= scrollableContainer.scrollWidth) {
                setAttribute('disabled', '', rightButton);
            }
            if(scrollableContainer.scrollLeft <= 0) {
                setAttribute('disabled', '', leftButton);
            }
        }, scrollableContainer);

        on('resize', () => {
            const isActuallyScrollable = scrollableContainer.scrollWidth > scrollableContainer.clientWidth;
            if(isActuallyScrollable) {
                removeAttribute('hidden', scrollButtons);
            } else {
                setAttribute('hidden', '', scrollButtons);
            }
        }, window)
    });
}